(function () {
  'use strict';

  var loaded = {};

  function loadCSS(href) {
    if (loaded[href]) return;
    loaded[href] = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function observe() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-lazy-css]').forEach(function (el) {
        el.dataset.lazyCss.split(',').forEach(loadCSS);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var hrefs = entry.target.dataset.lazyCss;
          if (hrefs) hrefs.split(',').forEach(loadCSS);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 0px' });

    document.querySelectorAll('[data-lazy-css]').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
